import { cardItems } from '@/mocks/home';

const cardImages = [
  'https://readdy.ai/api/search-image?query=Celebrity%20at%20press%20conference%20with%20dramatic%20lighting%2C%20scandal%20theme%2C%20warm%20crimson%20and%20amber%20tones%2C%20intense%20media%20scrutiny%2C%20editorial%20photography%2C%20high%20contrast%2C%20mysterious%20atmosphere&width=800&height=450&seq=card-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Mask%20falling%20off%20elegant%20face%20revealing%20truth%2C%20dramatic%20warm%20lighting%2C%20duality%20theme%2C%20crimson%20and%20gold%20tones%2C%20editorial%20photography%2C%20deep%20shadows%2C%20mysterious%20mood&width=800&height=450&seq=card-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Envelope%20with%20confidential%20stamp%20on%20dark%20desk%2C%20whistleblower%20theme%2C%20warm%20amber%20spotlight%2C%20dramatic%20atmosphere%2C%20editorial%20photography%2C%20high%20contrast%2C%20investigative%20mood&width=800&height=450&seq=card-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Empty%20concert%20venue%20with%20scattered%20tickets%20on%20floor%2C%20cancellation%20aftermath%2C%20warm%20crimson%20lighting%2C%20dramatic%20atmosphere%2C%20editorial%20photography%2C%20deep%20shadows%2C%20mysterious%20mood&width=800&height=450&seq=card-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Film%20set%20with%20warning%20signs%20and%20caution%20tape%2C%20safety%20incident%20theme%2C%20warm%20amber%20and%20crimson%20lighting%2C%20dramatic%20editorial%20photography%2C%20high%20contrast%2C%20mysterious%20industrial%20atmosphere&width=800&height=450&seq=card-05&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Empty%20office%20with%20unpaid%20invoices%20scattered%2C%20worker%20rights%20dispute%20theme%2C%20warm%20crimson%20and%20gold%20lighting%2C%20dramatic%20atmosphere%2C%20editorial%20photography%2C%20deep%20shadows%2C%20tense%20mood&width=800&height=450&seq=card-06&orientation=landscape',
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">热门文章</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.map((item, idx) => (
            <div
              key={item.id}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/60 hover:border-secondary-300 transition-colors cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={cardImages[idx]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded text-[10px] font-bold bg-accent-500 text-white">{item.tag}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-bold text-foreground-900 group-hover:text-accent-600 transition-colors line-clamp-2 leading-snug">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">{item.desc}</p>
                <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/60">
                  <span className="text-[11px] text-foreground-400">{item.date}</span>
                  <span className="text-[11px] text-foreground-400">{item.author}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}